import Link from 'next/link';
import styles from './TestEds.module.scss';

export const EdsSetup = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Настройка ЭП на рабочем месте</h1>

                <p>Для работы с ЭП на нашей площадке необходимо:</p>
                <ol>
                    <li>
                        Убедиться в том, что Ваша система
                        <Link href="/test_eds/#CryptoSetupInfo">
                            <a title="Перейти к проверке системы">
                                {' '}
                                соответствует требованиям
                            </a>
                        </Link>
                        .
                    </li>
                    <li>
                        Подключить к USB-порту Вашего компьютера полученный в
                        удостоверяющем центре flash-накопитель, содержащий ЭП.
                        <br />
                        Если у Вас еще нет электронной подписи, Вы можете{' '}
                        <Link href="get_eds/">
                            <a>получить ее в нашем удостоверяющем центре</a>
                        </Link>
                        .<br />В случае если Ваш сертификат ЭП находится на
                        <strong>{' rutoken '}</strong>(
                        <a
                            href="http://www.rutoken.ru/support/download/drivers-for-windows/"
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                            title="Перейти к загрузке драйвера для rutoken"
                        >
                            драйвер
                        </a>
                        ) или
                        <strong>{' eToken '}</strong>(
                        <a
                            href="http://www.aladdin-rd.ru/support/downloads/etoken/"
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                            title="Перейти к загрузке драйвера для eToken"
                        >
                            драйвер
                        </a>
                        ) предварительно необходимо установить драйвера.
                        <img
                            src="/assets/dummy-data/instructions/flash.png"
                            alt="ЭП"
                            title="ЭП"
                        />
                    </li>
                    <li>
                        Установить программу
                        <a
                            href="https://www.cryptopro.ru/products/csp/downloads"
                            target="_blank"
                            title="Перейти к загрузке КриптоПРО CSP"
                            rel="nofollow noopener noreferrer"
                        >
                            {' КриптоПРО CSP '}
                        </a>
                        (или одного из российских сертифицированных
                        криптопровайдеров) подходящей
                        <a
                            href="https://www.cryptopro.ru/products/csp/compare"
                            target="_blank"
                            title="Перейти к сравнению версий"
                            rel="nofollow noopener noreferrer"
                        >
                            {' версии '}
                        </a>
                        .
                        <br />
                        <span>
                            Рекомендуем использовать сертифицированную версию
                        </span>
                        .
                        <Link href="/test_eds/csp_setup_linux/">
                            <a title="Инструкция по установке КриптоПРО CSP в Linux">
                                {' Инструкция по установке в Linux '}
                            </a>
                        </Link>
                        (в Windows следуйте указаниям программы-установщика).
                        <img
                            src="/assets/dummy-data/instructions/cryptopro.png"
                            alt="КриптоПРО CSP"
                        />
                    </li>
                    <li>
                        Установить корневые сертификаты, предоставленные
                        удостоверяющим центром (
                        <Link href="/test_eds/cert_install/">
                            <a title="Инструкция по установке сертификатов в Windows">
                                Windows
                            </a>
                        </Link>
                        {' | '}
                        <Link href="/test_eds/cert_install_linux/">
                            <a title="Инструкция по установке сертификатов в Linux">
                                Linux
                            </a>
                        </Link>
                        ).
                    </li>
                    <li>
                        Установить и настроить КриптоПРО ЭЦП Browser Plug-In (
                        <Link href="/test_eds/plugin_setup/">
                            <a title="Инструкция по настройке КриптоПРО ЭЦП Browser Plug-In в Windows">
                                Windows
                            </a>
                        </Link>
                        {' | '}
                        <Link href="/test_eds/plugin_setup_linux/">
                            <a title="Инструкция по настройке КриптоПРО ЭЦП Browser Plug-In в Linux">
                                Linux
                            </a>
                        </Link>
                        ).
                    </li>
                    <li>
                        <Link href="/test_eds/attach_cert/">
                            <a title="Инструкция по прикреплению ЭП">
                                Прикрепить ЭП к профилю
                            </a>
                        </Link>
                        .
                    </li>
                </ol>
            </div>
        </div>
    );
};
